import { useEffect, useRef } from 'react';

/**
 * Hook para marcar artigo como lido após tempo definido
 * Segue Atomic Design - lógica extraída do ArticleModal
 */
const useMarkAsRead = (article, isOpen, onToggleRead, delay = 5000) => {
  const timerRef = useRef(null);

  useEffect(() => {
    // Se o modal está aberto, artigo existe e não está marcado como lido
    if (isOpen && article && !article.isRead && onToggleRead) {
      // Configurar temporizador
      timerRef.current = setTimeout(() => {
        onToggleRead(article._id);
      }, delay);
    }

    // Cleanup
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [isOpen, article, onToggleRead, delay]);

  return timerRef;
};

export default useMarkAsRead;
